/*
 * Copyright 2023 StarTree Inc.
 *
 * All rights reserved. Confidential and proprietary information of StarTree Inc.
 */

import Box from "@material-ui/core/Box";
import { AppBarV1, LinkButtonV1, LinkV1 } from "@startree-ui/platform-ui";
import React, { FunctionComponent, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as StartreeIcon } from "../../../../assets/images/startree-icon.svg";
import { useEnvironmentInfoContext } from "../../environment-info-provider/environment-info-provider.component";
import { WorkspaceSwitcher } from "../../workspace/workspace-switcher/workspace-switcher.component";
import { getNavbarLinks } from "./app.header.utils";
import { UserAccountMenu } from "./user-account-menu.component";

export const AppHeader: FunctionComponent = () => {
    const { t } = useTranslation();
    const {
        envFlags: { isSharedSaasEnv },
    } = useEnvironmentInfoContext();

    const navbarLinks = useMemo(() => getNavbarLinks(t, isSharedSaasEnv), []);

    return (
        <AppBarV1>
            <Box
                alignItems="center"
                display="flex"
                flexDirection="row"
                gridGap={12}
            >
                <Box clone alignItems="center" display="flex">
                    <LinkV1
                        color="textSecondary"
                        data-testid="app-header-logo-link"
                        href="/"
                        variant="h4"
                    >
                        <StartreeIcon height={40} width={40} />
                        {t("label.data-manager")}
                    </LinkV1>
                </Box>

                <WorkspaceSwitcher />
            </Box>
            <Box display="flex" gridGap={1} mr={-1}>
                {navbarLinks.map(({ label, link, icon: Icon }, idx) => (
                    <LinkButtonV1
                        externalLink
                        color="default"
                        data-testid={`app-header-${label
                            .toLowerCase()
                            .split(" ")
                            .join("-")}-link`}
                        href={link}
                        key={idx}
                        target="_blank"
                    >
                        {label}
                        <Box pr={1} />
                        <Icon fontSize="small" />
                    </LinkButtonV1>
                ))}
                <UserAccountMenu />
            </Box>
        </AppBarV1>
    );
};
